import React, { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import {
  FiMenu,
  FiX,
  FiChevronDown,
  FiArrowLeft,
  FiBriefcase,
  FiUsers,
  FiShield,
  FiTool,
} from "react-icons/fi";
import "./menu.css";

const Menu = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const megaRef = useRef(null);

  const handleNavClick = () => {
  setMenuOpen(false);
  setServicesOpen(false);
};

  /* ================= DESKTOP EDGE DETECTION ================= */
  const alignMegaMenu = () => {
    if (!megaRef.current) return;

    // 🚫 Mobile: reset styles
    if (window.innerWidth < 992) {
      megaRef.current.style.left = "";
      megaRef.current.style.right = "";
      megaRef.current.style.transform = "";
      return;
    }

    const rect = megaRef.current.getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    if (rect.right > viewportWidth) {
      megaRef.current.style.left = "auto";
      megaRef.current.style.right = "0";
      megaRef.current.style.transform = "none";
    } else {
      megaRef.current.style.left = "-50%";
      megaRef.current.style.right = "auto";
      megaRef.current.style.transform = "translateX(-50%)";
    }
  };

  // Run when services open + on resize
  useEffect(() => {
    if (servicesOpen) {
      alignMegaMenu();
      window.addEventListener("resize", alignMegaMenu);
    }

    return () => {
      window.removeEventListener("resize", alignMegaMenu);
    };
  }, [servicesOpen]);

  return (
    <header className="hj-header">
      <div className="container">
        <div className="hj-nav">

          {/* LOGO */}
          <NavLink to="/" className="hj-logo">
            <img src="/assets/img/logo.png" alt="Helperji" />
          </NavLink>

          {/* TOGGLE */}
          <button
            className="hj-toggle"
            onClick={() => {
              setMenuOpen(!menuOpen);
              setServicesOpen(false);
            }}
          >
            {menuOpen ? <FiX /> : <FiMenu />}
          </button>

          {/* MENU */}
          <ul className={`hj-menu ${menuOpen ? "open" : ""}`}>
            <li><NavLink to="/" onClick={handleNavClick}>Home</NavLink></li>
            <li><NavLink to="/about-us" onClick={handleNavClick}>About Us</NavLink></li>

            {/* SERVICES */}
            <li className="hj-mega">
              <span onClick={() => setServicesOpen(true)}>
                Services <FiChevronDown />
              </span>

              <div
                ref={megaRef}
                className={`hj-mega-menu ${servicesOpen ? "show" : ""}`}
              >
                {/* MOBILE BACK */}
                <div className="hj-mega-back">
                  <button onClick={() => setServicesOpen(false)}>
                    <FiArrowLeft /> Back
                  </button>
                </div>

                <div className="row">
                  <div className="col-lg-4 col-md-6">
                    <NavLink to="commercial-cleaning-services" onClick={handleNavClick}><h6><FiBriefcase /> Commercial Cleaning Services</h6></NavLink>
                    <NavLink to="commercial-cleaning-services-noida" onClick={handleNavClick}>Commercial Cleaning Services Noida</NavLink>
                    <NavLink to="commercial-cleaning-services-delhi" onClick={handleNavClick}>Commercial Cleaning Services Delhi</NavLink>
                    <NavLink to="commercial-cleaning-services-gurugram" onClick={handleNavClick}>Commercial Cleaning Services Gurugram</NavLink>
                    <NavLink to="commercial-cleaning-services-ghaziabad" onClick={handleNavClick}>Commercial Cleaning Services Ghaziabad </NavLink>
                  </div>

                  <div className="col-lg-4 col-md-6">
                    <NavLink to="housekeeping-manpower-services" onClick={handleNavClick}><h6><FiUsers /> Housekeeping Manpower Services</h6></NavLink>
                    <NavLink to="housekeeping-manpower-services-noida" onClick={handleNavClick}>Housekeeping Manpower Services Noida</NavLink>
                    <NavLink to="housekeeping-manpower-services-delhi" onClick={handleNavClick}>Housekeeping Manpower Services Delhi</NavLink>
                    <NavLink to="housekeeping-manpower-services-ghaziabad" onClick={handleNavClick}>Housekeeping Manpower Services Ghaziabad</NavLink>
                    <NavLink to="housekeeping-manpower-services-gurugram" onClick={handleNavClick}>Housekeeping Manpower Services Gurugram</NavLink>
                  </div>

                  <div className="col-lg-4 col-md-6">
                    <h6><FiShield /> Security Services</h6>
                    <NavLink to="security-guard-services" onClick={handleNavClick}>Security Guards Services</NavLink>
                    <NavLink to="private-security-services" onClick={handleNavClick}>Private Security Services</NavLink>
                    <h6><FiTool /> Other Staff</h6>
                    <NavLink to="pantry-boy-services" onClick={handleNavClick}>Pantry Boy Services</NavLink>
                    <NavLink to="assembly-line-manpower" onClick={handleNavClick}>Assembly Line Manpower</NavLink>
                  </div>
                </div>
              </div>
            </li>
            <li><NavLink to="/contact-us" onClick={handleNavClick}>Contact Us</NavLink></li>
            <li><NavLink to="/blogs" onClick={handleNavClick}>Blogs</NavLink></li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Menu;
